export const taxRatePermissions = {
    VIEW: {
        key: 'reports.view.tax.rate',
        name: 'View Tax Rate'
    },
    FULL: {
        key: 'reports.full.tax.rate',
        name: 'View,Create and Edit Tax Rate'
    }
}